<div style="padding: 5px 0" [matTooltip]="tooltip + ' ' + value + '%'">
    <mat-progress-bar mode="determinate" [value]="value" [color]="color">
    </mat-progress-bar>
</div>